module.exports = __webpack_public_path__ + "img/multi-select-icon.b7a25c5e.svg";